/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthAdminRouteImport } from './routes/_auth.admin'
import { Route as AuthReviewIndexRouteImport } from './routes/_auth.review.index'
import { Route as AuthProjectsIndexRouteImport } from './routes/_auth.projects.index'
import { Route as AuthPaymentOrdersIndexRouteImport } from './routes/_auth.payment-orders.index'
import { Route as AuthCrmProfilesIndexRouteImport } from './routes/_auth.crm-profiles.index'
import { Route as AuthBootstrapIndexRouteImport } from './routes/_auth.bootstrap.index'
import { Route as AuthProjectsProjectIdRouteImport } from './routes/_auth.projects.$projectId'
import { Route as AuthPaymentOrdersEmailIdRouteImport } from './routes/_auth.payment-orders.$emailId'
import { Route as AuthProjectsProjectIdTimelineRouteImport } from './routes/_auth.projects.$projectId.timeline'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAdminRoute = AuthAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReviewIndexRoute = AuthReviewIndexRouteImport.update({
  id: '/review/',
  path: '/review/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProjectsIndexRoute = AuthProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPaymentOrdersIndexRoute = AuthPaymentOrdersIndexRouteImport.update({
  id: '/payment-orders/',
  path: '/payment-orders/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCrmProfilesIndexRoute = AuthCrmProfilesIndexRouteImport.update({
  id: '/crm-profiles/',
  path: '/crm-profiles/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBootstrapIndexRoute = AuthBootstrapIndexRouteImport.update({
  id: '/bootstrap/',
  path: '/bootstrap/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProjectsProjectIdRoute = AuthProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPaymentOrdersEmailIdRoute =
  AuthPaymentOrdersEmailIdRouteImport.update({
    id: '/payment-orders/$emailId',
    path: '/payment-orders/$emailId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthProjectsProjectIdTimelineRoute =
  AuthProjectsProjectIdTimelineRouteImport.update({
    id: '/timeline',
    path: '/timeline',
    getParentRoute: () => AuthProjectsProjectIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthAdminRoute
  '/payment-orders/$emailId': typeof AuthPaymentOrdersEmailIdRoute
  '/projects/$projectId': typeof AuthProjectsProjectIdRouteWithChildren
  '/bootstrap/': typeof AuthBootstrapIndexRoute
  '/crm-profiles/': typeof AuthCrmProfilesIndexRoute
  '/payment-orders/': typeof AuthPaymentOrdersIndexRoute
  '/projects/': typeof AuthProjectsIndexRoute
  '/review/': typeof AuthReviewIndexRoute
  '/projects/$projectId/timeline': typeof AuthProjectsProjectIdTimelineRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthAdminRoute
  '/payment-orders/$emailId': typeof AuthPaymentOrdersEmailIdRoute
  '/projects/$projectId': typeof AuthProjectsProjectIdRouteWithChildren
  '/bootstrap': typeof AuthBootstrapIndexRoute
  '/crm-profiles': typeof AuthCrmProfilesIndexRoute
  '/payment-orders': typeof AuthPaymentOrdersIndexRoute
  '/projects': typeof AuthProjectsIndexRoute
  '/review': typeof AuthReviewIndexRoute
  '/projects/$projectId/timeline': typeof AuthProjectsProjectIdTimelineRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/admin': typeof AuthAdminRoute
  '/_auth/payment-orders/$emailId': typeof AuthPaymentOrdersEmailIdRoute
  '/_auth/projects/$projectId': typeof AuthProjectsProjectIdRouteWithChildren
  '/_auth/bootstrap/': typeof AuthBootstrapIndexRoute
  '/_auth/crm-profiles/': typeof AuthCrmProfilesIndexRoute
  '/_auth/payment-orders/': typeof AuthPaymentOrdersIndexRoute
  '/_auth/projects/': typeof AuthProjectsIndexRoute
  '/_auth/review/': typeof AuthReviewIndexRoute
  '/_auth/projects/$projectId/timeline': typeof AuthProjectsProjectIdTimelineRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admin'
    | '/payment-orders/$emailId'
    | '/projects/$projectId'
    | '/bootstrap/'
    | '/crm-profiles/'
    | '/payment-orders/'
    | '/projects/'
    | '/review/'
    | '/projects/$projectId/timeline'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/admin'
    | '/payment-orders/$emailId'
    | '/projects/$projectId'
    | '/bootstrap'
    | '/crm-profiles'
    | '/payment-orders'
    | '/projects'
    | '/review'
    | '/projects/$projectId/timeline'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/_auth/admin'
    | '/_auth/payment-orders/$emailId'
    | '/_auth/projects/$projectId'
    | '/_auth/bootstrap/'
    | '/_auth/crm-profiles/'
    | '/_auth/payment-orders/'
    | '/_auth/projects/'
    | '/_auth/review/'
    | '/_auth/projects/$projectId/timeline'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/admin': {
      id: '/_auth/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthAdminRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/review/': {
      id: '/_auth/review/'
      path: '/review'
      fullPath: '/review/'
      preLoaderRoute: typeof AuthReviewIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/projects/': {
      id: '/_auth/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthProjectsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payment-orders/': {
      id: '/_auth/payment-orders/'
      path: '/payment-orders'
      fullPath: '/payment-orders/'
      preLoaderRoute: typeof AuthPaymentOrdersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/crm-profiles/': {
      id: '/_auth/crm-profiles/'
      path: '/crm-profiles'
      fullPath: '/crm-profiles/'
      preLoaderRoute: typeof AuthCrmProfilesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/bootstrap/': {
      id: '/_auth/bootstrap/'
      path: '/bootstrap'
      fullPath: '/bootstrap/'
      preLoaderRoute: typeof AuthBootstrapIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/projects/$projectId': {
      id: '/_auth/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AuthProjectsProjectIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/payment-orders/$emailId': {
      id: '/_auth/payment-orders/$emailId'
      path: '/payment-orders/$emailId'
      fullPath: '/payment-orders/$emailId'
      preLoaderRoute: typeof AuthPaymentOrdersEmailIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/projects/$projectId/timeline': {
      id: '/_auth/projects/$projectId/timeline'
      path: '/timeline'
      fullPath: '/projects/$projectId/timeline'
      preLoaderRoute: typeof AuthProjectsProjectIdTimelineRouteImport
      parentRoute: typeof AuthProjectsProjectIdRoute
    }
  }
}

interface AuthProjectsProjectIdRouteChildren {
  AuthProjectsProjectIdTimelineRoute: typeof AuthProjectsProjectIdTimelineRoute
}

const AuthProjectsProjectIdRouteChildren: AuthProjectsProjectIdRouteChildren = {
  AuthProjectsProjectIdTimelineRoute: AuthProjectsProjectIdTimelineRoute,
}

const AuthProjectsProjectIdRouteWithChildren =
  AuthProjectsProjectIdRoute._addFileChildren(
    AuthProjectsProjectIdRouteChildren,
  )

interface AuthRouteChildren {
  AuthAdminRoute: typeof AuthAdminRoute
  AuthPaymentOrdersEmailIdRoute: typeof AuthPaymentOrdersEmailIdRoute
  AuthProjectsProjectIdRoute: typeof AuthProjectsProjectIdRouteWithChildren
  AuthBootstrapIndexRoute: typeof AuthBootstrapIndexRoute
  AuthCrmProfilesIndexRoute: typeof AuthCrmProfilesIndexRoute
  AuthPaymentOrdersIndexRoute: typeof AuthPaymentOrdersIndexRoute
  AuthProjectsIndexRoute: typeof AuthProjectsIndexRoute
  AuthReviewIndexRoute: typeof AuthReviewIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAdminRoute: AuthAdminRoute,
  AuthPaymentOrdersEmailIdRoute: AuthPaymentOrdersEmailIdRoute,
  AuthProjectsProjectIdRoute: AuthProjectsProjectIdRouteWithChildren,
  AuthBootstrapIndexRoute: AuthBootstrapIndexRoute,
  AuthCrmProfilesIndexRoute: AuthCrmProfilesIndexRoute,
  AuthPaymentOrdersIndexRoute: AuthPaymentOrdersIndexRoute,
  AuthProjectsIndexRoute: AuthProjectsIndexRoute,
  AuthReviewIndexRoute: AuthReviewIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
